import React, { useEffect, useRef } from 'react';

const GreenOrb: React.FC = () => {
    const rotatingContainerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        // Cette fonction contrôle la rotation aléatoire et fluide
        const randomRotation = () => {
            const rotatingElement = rotatingContainerRef.current;
            if (!rotatingElement) return;

            // Variables pour gérer la rotation
            let currentRotation = 0;
            let rotationSpeed = Math.random() * 2 + 1; // Vitesse initiale entre 1 et 3 degrés par seconde
            let rotationDirection = 1; // 1 pour sens horaire
            let lastTimestamp: number | null = null;

            // Fonction pour changer aléatoirement la vitesse de rotation
            function changeRotationSpeed() {
                // Vitesse aléatoire entre 0.5 et 4 degrés par seconde
                rotationSpeed = Math.random() * 3.5 + 0.5;

                // Programmer le prochain changement de vitesse (entre 3 et 8 secondes)
                setTimeout(changeRotationSpeed, Math.random() * 5000 + 3000);
            }

            // Fonction d'animation
            function animate(timestamp: number) {
                if (!lastTimestamp) {
                    lastTimestamp = timestamp;
                }

                // Calculer le delta de temps depuis la dernière frame
                const deltaTime = timestamp - lastTimestamp;
                lastTimestamp = timestamp;

                // Calculer l'incrément de rotation en fonction de la vitesse
                const rotationIncrement = (rotationSpeed * deltaTime) / 1000 * rotationDirection;

                // Mettre à jour la rotation actuelle
                currentRotation += rotationIncrement;

                // Appliquer la rotation
                if (rotatingElement) {
                    rotatingElement.style.transform = `rotate(${currentRotation}deg)`;
                }

                // Continuer l'animation
                requestAnimationFrame(animate);
            }

            // Démarrer le changement aléatoire de vitesse
            changeRotationSpeed();

            // Démarrer l'animation
            requestAnimationFrame(animate);
        };

        // Démarrer la rotation
        randomRotation();
    }, []);

    return (
        <div className="container flex justify-center items-center relative w-[50px] h-[50px] mb-6">
            <div ref={rotatingContainerRef} className="rotating-container relative w-[50px] h-[50px] transition-transform duration-8000 ease-in-out">
                <div className="glow absolute -top-2 -left-2 -right-2 -bottom-2 rounded-full bg-[radial-gradient(circle_at_center,rgba(166,186,133,0.3)_0%,rgba(166,186,133,0.1)_60%,transparent_80%)] blur-md -z-10"></div>
                <div className="sphere w-[50px] h-[50px] rounded-full relative overflow-hidden bg-[radial-gradient(circle_at_35%_25%,rgba(196,216,163,0.8)_10%,rgba(166,186,133,0.9)_40%,rgba(136,156,103,0.9)_60%,rgba(106,126,73,0.9)_90%)]">
                    <div className="highlight-main absolute top-[10%] left-[10%] w-[45%] h-[45%] rounded-full bg-[radial-gradient(circle_at_center,rgba(255,255,255,0.95)_0%,rgba(255,255,255,0.6)_40%,transparent_80%)] blur-[3px] animate-moveHighlightMain"></div>
                    <div className="highlight-1 absolute top-[45%] right-[14%] w-[11%] h-[85%] rounded-full bg-[radial-gradient(circle_at_center,rgba(255,255,255,0.85)_10%,rgba(255,255,255,0.4)_70%,transparent_100%)] blur-[5px] rotate-45 animate-moveHighlight1"></div>
                    <div className="highlight-2 absolute bottom-[-4%] left-[-7%] w-full h-[30%] rounded-full bg-[radial-gradient(circle_at_center,rgba(255,255,255,0.7)_10%,rgba(255,255,255,0.3)_70%,transparent_100%)] blur-[5px] rotate-[202deg] animate-moveHighlight2"></div>
                </div>
            </div>
        </div>
    );
};

export default GreenOrb;